import { useState } from "react";
import { Plus } from "lucide-react";
import { useRisks } from "@/hooks/useLive";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { SeverityBadge } from "@/components/ui/SeverityBadge";
import { Avatar } from "@/components/ui/Avatar";
import { CreateRiskModal } from "@/components/forms/CreateModals";
import { primaryOwner } from "@/lib/utils";

export function RisksPanel() {
  const RISKS = useRisks();
  const [addOpen, setAddOpen] = useState(false);
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between gap-3">
          <div>
            <CardTitle>Risks & flags</CardTitle>
            <p className="text-caption text-muted-foreground">
              Ranked by severity. Each risk has an owner and a resolution path.
            </p>
          </div>
          <button
            onClick={() => setAddOpen(true)}
            className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-caption font-medium text-white hover:bg-primary/90"
          >
            <Plus size={14} /> Add risk
          </button>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        {RISKS.map((r) => (
          <div
            key={r.id}
            className={`rounded-lg border-l-4 p-4 ${
              r.severity === "high"
                ? "border-destructive bg-destructive/5"
                : r.severity === "medium"
                  ? "border-amber-500 bg-amber-50"
                  : "border-slate-300 bg-slate-50"
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="text-h4 font-semibold text-foreground">{r.title}</div>
              <SeverityBadge severity={r.severity} />
            </div>
            {r.detail && <p className="mt-2 text-body text-foreground/90 leading-relaxed">{r.detail}</p>}
            <div className="mt-3 flex flex-wrap items-center gap-3">
              <span className="flex items-center gap-2">
                <Avatar name={primaryOwner(r.owner)} size="xs" />
                <span className="text-caption text-muted-foreground">Owner · {r.owner || "—"}</span>
              </span>
              {r.phase && (
                <span className="inline-flex items-center rounded-full border border-sky-200 bg-sky-50 px-2 py-0.5 text-micro font-medium text-sky-700">
                  Phase · {r.phase}
                </span>
              )}
            </div>
          </div>
        ))}
      </CardContent>
      <CreateRiskModal open={addOpen} onClose={() => setAddOpen(false)} />
    </Card>
  );
}
